import { useEffect } from 'react';
import { WorkspacePanelWithQueue } from '../panels/workspace-queue-exists';
import { QueueStore } from './store/queue-store';

export function useSyncWorkspacePanelToQueueStore(
    workspacePanel: WorkspacePanelWithQueue,
    queueStore: QueueStore
) {
    useEffect(() => {
        if (workspacePanel.id !== queueStore.workspacePanel.id) {
            queueStore.setWorkspacePanel(workspacePanel);
        }
    }, [queueStore, workspacePanel]);
}
